/**
 * Sprachwaehler im Shop-Kopf — Auf- und Zuklappen.
 *
 * Gehoert zu snippets/fu-sprachwahl.liquid, Variante 'kopf'. Die Drawer-Variante
 * kommt ohne diese Datei aus, sie benutzt <details>.
 *
 * Diese Datei schaltet NUR das Panel. Der Sprachwechsel selbst haengt nicht an
 * ihr: Jeder Eintrag ist ein <button type="submit" name="language_code"> in
 * Shopifys {% form 'localization' %} und sendet das Formular auch ohne eine
 * Zeile JavaScript.
 *
 * Bewusst ohne Horizons Component-Basisklasse und ohne
 * <dropdown-localization-component>. Deren #updateWidth() liest
 * this.refs.localizationForm.offsetWidth ohne Absicherung
 * (assets/localization.js:475) — in einem reinen Sprachwaehler gibt es dieses
 * Formular nicht, und der Zugriff wuerfe beim Oeffnen eine Ausnahme. Der eigene
 * Weg ist kuerzer als die Ausnahmebehandlung dafuer.
 */
class FuSprachwahl extends HTMLElement {
  #knopf = null;
  #panel = null;

  connectedCallback() {
    this.#knopf = this.querySelector('[data-fu-spw-knopf]');
    this.#panel = this.querySelector('[data-fu-spw-panel]');

    if (!this.#knopf || !this.#panel) return;

    this.#knopf.addEventListener('click', this.#umschalten);
  }

  disconnectedCallback() {
    // Der Klick-Horcher haengt am document und muss mit, sonst bleibt er
    // liegen, wenn der Header neu gerendert wird (Theme-Editor, Section-Rerender).
    document.removeEventListener('click', this.#beiKlickAussen);
    this.removeEventListener('keydown', this.#beiTaste);
  }

  get #istOffen() {
    return !this.#panel.hasAttribute('hidden');
  }

  #umschalten = () => {
    this.#istOffen ? this.#schliessen() : this.#oeffnen();
  };

  #oeffnen() {
    this.#panel.removeAttribute('hidden');
    this.#knopf.setAttribute('aria-expanded', 'true');

    document.addEventListener('click', this.#beiKlickAussen);
    this.addEventListener('keydown', this.#beiTaste);

    // Fokus auf die laufende Sprache, nicht auf den ersten Eintrag: Wer mit der
    // Tastatur oeffnet, steht dann dort, wo er gerade ist, und sieht am
    // Fokusring, welche Sprache aktiv ist.
    const aktueller = this.#panel.querySelector('[aria-current="true"]');
    (aktueller instanceof HTMLElement ? aktueller : this.#panel.querySelector('button'))?.focus();
  }

  #schliessen(fokusZurueck = false) {
    if (!this.#istOffen) return;

    this.#panel.setAttribute('hidden', '');
    this.#knopf.setAttribute('aria-expanded', 'false');

    document.removeEventListener('click', this.#beiKlickAussen);
    this.removeEventListener('keydown', this.#beiTaste);

    if (fokusZurueck) this.#knopf.focus();
  }

  #beiKlickAussen = (ereignis) => {
    const ziel = ereignis.target;
    if (ziel instanceof Node && !this.contains(ziel)) this.#schliessen();
  };

  #beiTaste = (ereignis) => {
    if (ereignis.key === 'Escape') {
      ereignis.stopPropagation();
      this.#schliessen(true);
    }
  };
}

if (!customElements.get('fu-sprachwahl')) {
  customElements.define('fu-sprachwahl', FuSprachwahl);
}
